import React, { Component, useState, useEffect } from 'react';
import  './styles.css'
import { Container, Row,  } from "reactstrap";

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }

const TextCol = ({Heading, Context, SubHeading, i, img}) => {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
        setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    if (i%2 === 1 && windowDimensions.width>768){
        return (
            <Row className='content' id={Heading}>
                <div className='About-Section'>
                    <h4>
                        {Heading}
                    </h4>
                    <h6 className="subHeading">
                        {SubHeading}
                    </h6>
                    {Context}
                </div>
                <img src={img} className="img2" alt={Heading}/>
            </Row>
            )
        }
    else{
        return (
            <Row className='content' id={Heading}>
                <img src={img} className="img2" alt={Heading}/>
                <div className='About-Section'>
                    <h4>
                        {Heading}
                    </h4>
                    <h6 className="subHeading">
                        {SubHeading}
                    </h6>
                    {Context}
                </div>
            </Row>)}
        
    }

class Courses extends Component {
    about = [{
        Heading: "Leadership Coaching",
        SubHeading: "Challenging and encouraging conversations",
        Context: 
            <div>
                <p>The coaching process could be part of an integrated leadership development programme or a series of 1:1 conversations for members of a leadership team or for specific individuals.</p><p>Coaching can happen in a variety of situations, face to face, taking a walk, over the phone or virtually.</p><p>Coaching sessions are aimed at:</p>
                <ul>
                <li>Creating a clear purpose, vision and values for yourself, team and the organisation</li>
                <li>Clarifying your goals and means to achieve them</li>
                <li>Development of new approaches and strategies to inspire, motivate and develop a team and individuals</li>
                <li>Enabling you and those around you to thrive</li>
                <li>Developing awareness and stepping into the most authentic, confident version of yourself</li>
                <li>Enabling positive transitions within the workplace, due to:
                    <ul>
                        <li>organisational changes</li>
                        <li>promotion to a bigger role</li>
                        <li>moving to a new phase of life</li>
                        <li>transitioning back into the workplace after a period of absence (e.g. maternity leave)</li>
                    </ul>
                </li>
                <li>Enabling a shift from unhelpful to helpful thinking</li>
                </ul>
                <p>We offer you the opportunity to thrive through challenging and encouraging conversations with someone who cares about you and listens deeply. Through which you will gain insights about yourself and practical tools to look after yourself, think and communicate clearly, achieve your goals and feel inspired.</p>
            </div>,
        img: "/images/photos/photo-1524758870432-af57e54afa26.avif"
    },
    {
        Heading: "Collaboration Events",
        SubHeading: "Increase collaboration across boundaries",
        Context: 
            <div>
                <p><i>‘The greatest power for change is in bringing groups of people together to talk about what they care about.’</i> -  Margaret Wheatley</p>
                <p></p>

                <p>We are passionate about getting people talking about what they care about and harnessing the wisdom of the 'whole group’ not just the official leaders.</p>

                <p>If you are looking to</p>
                <ul>
                    <li>increase collaboration across boundaries</li>
                    <li>engage a group of people around a theme they care about</li>
                    <li>bring a diverse group of people together to catalyse initiatives/activity</li>
                    <li>kick off an initiative creatively and inclusively</li>
                    <li>gather current thinking, opinions and ideas</li>
                    <li>get people talking about what they care about</li>
                </ul>

                <p>an ‘Open Space’ or ‘World Cafe’ event could be the solution</p>

                <p>We’ve several years of experience of facilitating open-space events for diverse groups of people from 20 to 80 or more. We’ve brought groups of people together across the same organisation from different business units, different functions and different countries to effect change and we’ve brought groups of people together across sectors including service users to improve the quality and outcomes of services across disciplines, professions and sectors.</p>

                <p>Feedback shows that we are skilful at putting people at ease and creating a safe space, so that people know that they matter and that their contribution is valued.</p>
            </div>,
        img: "/images/photos/photo-1515187029135-18ee286d815b.avif"
    },
    {
        Heading: "Thrive Programme",
        SubHeading: "Increase personal well-being and flourish",
        Context: <div>
            <p><b>Context</b></p>
            <p>In today’s hectic world, with complex work structures the workplace can often seem like an emotional roller coaster. Long hours, tight deadlines, and ever-increasing stakeholder demands can leave employees feeling worried, drained, and overwhelmed. And while a little pressure can help to stay focussed, energetic, motivated and able to meet new challenges in the workplace, too much pressure can have a lasting and damaging effect on, job satisfaction, morale, employee health and well being, work place performance and home life.</p>

            <p><b>Thrive</b></p>
            <p>Thrive is a programme that acknowledges the challenges faced and that as individuals we cannot always change or control conditions within our workplace. However we can change our relationship to these pressures, through</p>
            <ul>
                <li>increased self-awareness and understanding</li>
                <li>developing new skills in order to thrive</li>
                <li>building trust and understanding within teams</li>
            </ul>
            <p>Thrive programmes can be tailored to specific needs, can be part of personal or leadership development programmes. Thrive programmes have a profound positive impact with the workplace and personal lives of employees.</p>
        </div>,
        img: "/images/photos/photo-1598322978033-b51f009e599c.avif"
    }]
    render() {
        return ( <div>
            <Container>
                <Row>
                    <h2 className='Title'>
                        What we do
                    </h2>
                    <div className='navSection'>
                        <h4>
                            Courses and Facilitations
                        </h4>
                        <div className='navButtonsSection'>
                        {this.about.map((col) => {
                            const handleClick = () => {
                                const offsetTop  = document.getElementById(col.Heading).offsetTop;
                                window.scrollTo({
                                    top: offsetTop-100,
                                    behavior: "smooth"
                                });
                            };

                            return (
                                <div key={col.Heading} className='sectionLink'>
                                    <img className="vam" width={32} height={32} alt="Siddham vam" src="/images/photos/vam.png"/>
                                    <h6 className='NavHeading' onClick={handleClick}>{col.Heading}</h6>
                                    <img className="vam" width={32} height={32} alt="Siddham vam" src="/images/photos/vam.png"/>
                                </div>
                            )
                        })}
                        </div>
                    </div>
                </Row>
                {this.about.map((col, i) => (
                    <TextCol Heading={col.Heading} Context={col.Context} SubHeading={col.SubHeading} i={i + 1} img={col.img} key={col.Heading}/>
                ))}
            </Container>
        </div> );
    }
}
 
export default Courses;